import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

import { useMainQueryKey } from './useMainQueryKey'

export const useInvalidateMainQuery = () => {
  const queryClient = useQueryClient()
  const queryKey = useMainQueryKey()

  return React.useCallback(
    () => queryClient.invalidateQueries({ queryKey }),
    [queryClient, queryKey],
  )
}
